import React, { Component } from 'react';
import { FILE_URL,path } from './Constant';

let $=window.$;
export default class WhyUs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.data,
            static_text:props.static_text
        }
    }

    componentDidMount =()=>{
        setTimeout(() => {
                $('html, body').animate({
                    scrollTop: $("#welcome-area").offset().top-50
                }, 500);
        }, 500);
    }

    render() {
        return (
            <div id="welcome-area">
                <div className="row">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-12" id="why-us-div">
                                {/* <h4>{'Why Us'}</h4> */}
                                <p>{this.props.data.short_text}</p>
                                <img src={FILE_URL+'villas/'+this.props.data.image} className="img-fluid d-block" alt={'Why Us'} />
                           
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
